export default "__VITE_ASSET__8192ae42__"